import { CommonModule } from '@angular/common';
import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { Parc } from '../../Services/EntiteProjet';
import { EtatService } from '../../Services/etat';
import { CarteInstallationsComponent } from '../carte-installations/carte-installations';

@Component({
  selector: 'app-parc-liste-parcs',
  imports: [CommonModule, CarteInstallationsComponent],
  templateUrl: './parc-liste-parcs.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './parc-liste-parcs.css',
})
export class ParcListeParcsComponent {
  private readonly etat = inject(EtatService);

  parcs = input<Parc[]>([]);
  installations = this.etat.installations;
}
